<template>
  <div class="all_game">
    <div class="list">
      <div class="list_item search">
        <div class="search_tabs">
          <span :class="action.gameTypeId===''?'active':''" @click="getAllGameData">
            全部游戏
          </span>
          <span v-for="(item,index) in gameClass" :key="index" :class="action.gameTypeId === item.id ?'active':''"
              @click="gameClassClick(item)">
              {{ item.class_name }}
          </span>
        </div>
        <div class="search_input">
          <input type="text" v-model="search_input_text" @keyup.enter="searchBtnClick" :placeholder="cusSerSearch?'关键词搜索游戏或客服ID':'请输入关键词进行搜索'">
          <div class="search_btn" @click="searchBtnClick">
            <i class="el-icon-search"></i>
          </div>
        </div>
      </div>
      <div class="list_item opiton">
        <div>
          <span :class="action.firstChar===item?'active_A-Z':''" v-for="item in alphabet" :key="item" v-text="item"
              @click="onClickAlphabet(item)"></span>
        </div>
      </div>
      <div class="list_item history" v-if="historyGameList.length>0 && !accRecycle">
        <div class="historyTitle">
          <div class="titleText">
            最近浏览
          </div>
          <div class="clear" @mouseenter="clear = true" @mouseleave="clear = false" @click="clearHistory">
            <i class="el-icon-delete"></i>
            清空最近浏览
          </div>
        </div>
        <ul>
          <li v-for="item in historyGameList" :key="item.game_id" :title="item.game_name" @click="gamesClick(item)">
            <div class="game_img"><img :src="item.game_image" alt=""></div>
            <div class="game_name" :title="item.game_name">{{ item.game_name }}</div>
          </li>
        </ul>
      </div>
      <div class="list_item games">
        <ul>
          <li v-show="cusSerSearch" v-for="(item,index) in staffList" :key="`staffList${index}`" :title="`客服-${item.name}`" @click="staffClick(item)">
            <div class="game_img"><img :src="item.game_image" alt=""></div>
            <div class="game_name" :title="`客服-${item.name}`">客服-{{ item.name }}</div>
          </li>
          <li v-for="(item,index) in gameList" :key="`gameList${index}`" :title="item.game_name" @click="gamesClick(item)">
            <div class="game_img"><img :src="item.game_image" alt=""></div>
            <div class="game_name" :title="item.game_name">{{ item.game_name }}</div>
          </li>
        </ul>
      </div>
    </div>
    <wxChatGlobal :visible.sync="merVisible" :describe="customer_describe" :qr_code_url="qr_code_url"></wxChatGlobal>
  </div>
</template>
<script>
import {
  apiGameList,
  apiGameClass,
  apiHistoryList,
  apiHistoryAdd,
  apiHistoryDel,
  apiUserProductInfo,
  apiValuationDetail,
  apiRecyclingGameList,
  apiCustomerSearch,
  apiGetCustomerQrcodeInfo
} from "@/request/API";
import storage from "@/util/storage";
import wxChatGlobal from '../../views/chat/components/wxChatGlobal.vue';

export default {
  name: 'allgame',
  props: {
    //游戏点击函数
    gameClick: {
      type: Function,
      default: null
    },
    product_id: {
      type: [String, Number],
      default: ''
    },
    other: {
      type: Boolean,
      default: false,
    },
    accRecycle: {
      type: Boolean,
      default: false,
    },
    gameId: {
      type: [String, Number],
      default: ''
    },
    couponId: {
      type: [String, Number],
      default: ''
    },
    vouch: {
      type: Boolean,
      default: false
    },
    cusSerSearch: {
      type: Boolean,
      default: false
    }
  },
  components: {wxChatGlobal},
  data() {
    return {
      //游戏类型 && 首字母
      action: {
        gameTypeId: '',
        firstChar: "全部",
      },
      //A-Z
      alphabet: [],
      //搜索框文本
      search_input_text: '',
      //游戏列表
      gameList: [],
      //客服列表
      staffList:[],
      //游戏分类
      gameClass: [],
      //最近浏览
      historyGameList: [],
      //清空最近浏览Hover
      clear: false,
      // 站内信
      stationLetter: {},
      //无板块游戏
      otherGame: '',
      gameListApi: apiGameList,
      merVisible: false,
      customer_describe: '',
      qr_code_url: '',
      customer_qr_code_flag: '',
      //是否搜索
      searchClick:false
    }
  },
  methods: {
    /**
     * 估价号商联系客服选择游戏
     */
    gethaoshang(val) {
      let item = val.find(child => child.game_id == this.gameId)
      //选中游戏
      if (item) {
        this.gamesClick(item)
      }
    },
    //获取选择的站内信消息
    getApiValuationDetail(val) {
      const { pageType, product_id, game_id } = this.$route.query
      if(pageType === 'edit') {
        apiUserProductInfo({
          id: product_id,
          game_id,
        }).then(res => {
          this.stationLetter = res.data;
          this.gamesClick(res.data, true, this.stationLetter)
        })
        return
      }
      apiValuationDetail({
        id: this.product_id
      }).then(res => {
        this.stationLetter = res.data;
        let item = val.find(child => child.game_id == res.data.game_id)
        //选中游戏
        if (item) {
          this.gamesClick(item, true, this.stationLetter)
        }
      })
    },
    //首字母列表点击事件
    onClickAlphabet(item) {
      this.action.firstChar = item
      if (item === '全部') {
        item = ''
      }
      this.getGameList('', item, this.action.gameTypeId)
    },
    // 展开全部游戏 获取全部游戏列表
    getAllGameData() {
      this.action = {
        gameTypeId: '',
        firstChar: "全部",
      }
      this.getGameList()
    },
    // 游戏类型点击事件
    gameClassClick(data) {
      this.action = {
        gameTypeId: data.id,
        firstChar: "全部",
      }
      this.getGameList('', '', data.id)
    },
    //搜索按钮点击事件
    searchBtnClick() {
      this.$sensorsTrack.GameSearchClick(this.$route.name)
      this.action = {
        gameTypeId: '',
        firstChar: "全部",
      }
      if (this.cusSerSearch && this.search_input_text) {
        this.getCusSerCenter(this.search_input_text)
      }else{
        this.getGameList(this.search_input_text, '', '')
      }
    },
    /**
     * 获取全部游戏列表
     * @param match 搜索框
     * @param game_letter 首字母
     * @param game_class 游戏类别
     */
    getGameList(match, game_letter, game_class) {
      this.staffList = []
      if (game_class === '网络游戏') {
        game_class = '1'
      } else if (game_class === '手机游戏') {
        game_class = '2'
      }
      this.gameListApi({
        match: match,
        game_letter: game_letter,
        class_id: game_class,
        coupon_id: this.couponId
      }).then(res => {
        if (match) {
          this.searchClick = true
        }else{
          this.searchClick = false
        }
        // 选中站内信中的游戏
        if (this.product_id) {
          this.getApiValuationDetail(res.data)
        }
        // 站内信号商联系客服
        if (this.gameId) {
          this.gethaoshang(res.data)
        }
        this.gameList = res.data
        let otherGame = {}
        if (this.other) {
          for (let datumKey in res.data[res.data.findIndex(v => v.game_alias === 'wzry')]) {
            otherGame[datumKey] = res.data[res.data.findIndex(v => v.game_alias === 'wzry')][datumKey]
          }
          otherGame.game_id = 0
          otherGame.game_alias = 'wbkyx'
          otherGame.game_name = '无板块游戏'
          otherGame.game_image = 'https://images.pxb7.com/images/upload/image/20220823/1661244502950024.jpeg'
          otherGame.buy_list = [
            {is_work:1,work_id:'https://tb.53kf.com/code/worker/528d4f3bc25d9279010007a8c01daf5a4/11193141',work_name:"月月"},
            {is_work:1,work_id:'https://tb.53kf.com/code/worker/528d4f3bc25d9279010007a8c01daf5a4/11209101',work_name:"婧婧"},
          ]
        }
        let newGameList = []
        if (this.vouch) {
          res.data.forEach(item => {
            if (item.game_alias === 'yxlm' || item.game_alias === 'wzry' || item.game_alias === 'yuanshen' || item.game_alias === 'guangyu' || item.game_alias === 'cyhx') {
              newGameList.unshift(item)
            } else {
              newGameList.push(item)
            }
          })
          this.gameList = newGameList
        }
        if (this.other || this.vouch) {
          this.gameList.unshift(otherGame)
        }
        if (res.data.length === 0 && this.vouch) {
          this.gamesClick(otherGame)
        }
      })
    },

    /**
     * 获取游戏分类
     */
    getGameClass() {
      apiGameClass({}).then(res => {
        this.gameClass = res.data
      })
    },
    /**
     * 点击游戏
     * @param item 游戏
     */
    async gamesClick(item, next, sLetter) {
      if (item.game_id === 0) {
        this.gameClick(item, next, sLetter,this.searchClick,this.search_input_text)
        return
      }
      item = await this.gameListApi({
        match: item.game_name,
      })
      item = item.data[0]

      let ary = this.historyGameList
      if (storage.getItem('historyGameList')) {
        ary = JSON.parse(storage.getItem('historyGameList'))
        if (ary.findIndex(items => items.game_id === item.game_id) === -1) {
          ary.unshift(item)
        } else {
          ary.splice(ary.findIndex(items => items.game_id === item.game_id), 1)
          ary.unshift(item)
        }
        ary = ary.slice(0, 10)
        ary = ary.slice(0, 10)
      } else {
        ary = []
        ary.unshift(item)
      }
      storage.setItem('historyGameList', JSON.stringify(ary))
      this.historyGameList = ary
      this.gameClick(item, next, sLetter,this.searchClick,this.search_input_text)

    },

    /**
     * 清空最近浏览
     */
    clearHistory() {
      this.historyGameList = []
      storage.setItem('historyGameList', JSON.stringify(this.historyGameList))
    },

    /**
     * 获取最近浏览游戏列表
     */
    getHistoryList() {
      try {
        const historyGameList = JSON.parse(storage.getItem('historyGameList'))
        this.historyGameList = Array.isArray(historyGameList) ? historyGameList.filter(item => item.game_name !== '无板块游戏') : []
      } catch (e) {
        this.historyGameList = []
      }
    },

    /**
     * 获取游戏、客服列表
     * @param keyword 关键词
     */
    getCusSerCenter(keyword){
      apiCustomerSearch({
        keyword
      }).then(res=>{
        this.customer_qr_code_flag = res.data.customer_qr_code_flag
        this.gameList = res.data.games
        this.staffList = res.data.staff
      })
    },
    /**
     * 客服列表点击事件
     * @param item
     */
    staffClick(item){
      // window.open(item.link,'_blank')
      if(item.link){
        apiGetCustomerQrcodeInfo({
          type: 1
        }).then(res => {
          if(res.data.customer_qr_code_flag==1){
          // if(this.customer_qr_code_flag==1){
            let dict = res.data.dict
            for (const key in dict) {
              if(key == item.link){
                // console.log(dict[key]);
                this.customer_describe = item.customer_describe
                this.qr_code_url = item.qr_code_url
                break
              }
            }
            this.merVisible = true
          }else{
            this.$openIM({
              im_type: item.im_type,
              game_id: item.game_id,
              id: item.link,
              serviceId: item.link,
            })
          }
        })
      }else{
        this.$message.error('当前客服不在线')
      }
    },
    couponGame() {
    if(this.$route.params.coupon){
      this.gameListApi({
        coupon_id:this.couponId
      }).then(res => {
        this.historyGameList = JSON.parse(storage.getItem("historyGameList")).filter(v=>{
          for(let k of res.data){
            if(k.game_id == v.game_id){
              return v
            }
          }
        })
        setTimeout(() => {
          this.gameList = res.data;
        }, 50);
      })
    } else {
      // this.getAllGameData()
      // this.historyGameList = JSON.parse(storage.getItem("historyGameList"))
    }
  }
  }
  ,
  mounted() {
    // this.getApiValuationDetail()
    //获取首字母列表
    for (var i = 0; i < 26; i++) {
      this.alphabet.push(String.fromCharCode(65 + i))
    }
    this.alphabet.unshift('全部')

    if (this.accRecycle) {
      this.gameListApi = apiRecyclingGameList
    }
    //默认获取全部游戏列表
    this.getAllGameData()
    this.getGameClass()
    this.getHistoryList()
    setTimeout(() => {
      this.couponGame()
    }, 100);
  }
  ,
  watch: {}
  ,
  computed: {}
}
</script>

<style lang='less' scoped>
.all_game {
  width: 1200px;

  .list {
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 0 0 4px 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px 10px;

    .list_item {
      width: 1160px;
    }

    .search {
      min-height: 104px;
      background-color: var(--bg-card, #FFFFFF);
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 24px;

      .search_tabs {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        flex: 1;
        gap: 12px;

        span {
          min-width: 82px;
          height: 36px;
          line-height: 36px;
          margin: 0;
          padding: 0 16px;
          border-radius: 4px;
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          text-align: center;
          color: var(--text-secondary, #5A5F6B);
          background: transparent;
          cursor: pointer;
          box-sizing: border-box;
          transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
        }

        span:hover {
          color: var(--text-main, #1A1D24);
          background: var(--bg-tag, #F0EDE8);
        }

        .active {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          background: var(--primary, #FF5A1F);
          box-shadow: 0 8px 16px rgba(255, 90, 31, 0.22);
        }

        .active:hover {
          color: #FFFFFF;
          background: var(--primary-hover, #E84A12);
        }
      }

      .search_input {
        position: relative;
        width: 350px;
        flex: 0 0 350px;

        input {
          width: 100%;
          height: 46px;
          background: var(--bg-section, #F7F5F2);
          border-radius: 4px;
          border: 1px solid var(--border-soft, #E8E4DE);
          padding: 0 58px 0 20px;
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          color: var(--text-main, #111827);
          box-sizing: border-box;
          outline: none;
          transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
        }

        input:focus {
          background: var(--bg-card, #FFFFFF);
          border-color: var(--primary, #FF5A1F);
          box-shadow: none;
        }

        input::-webkit-input-placeholder {
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
        }

        .search_btn {
          width: 36px;
          height: 36px;
          position: absolute;
          top: 5px;
          right: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-sizing: border-box;
          transition: color 0.2s ease;

          &:hover {
            i {
              color: #1A1D24;
            }
          }

          i {
            font-size: 20px;
            font-weight: 600;
            color: var(--text-main, #1A1D24);
          }
        }
      }
    }

    .opiton {
      min-height: 56px;
      background: var(--bg-section, #F7F5F2);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-sizing: border-box;

      div {
        min-height: 54px;
        padding: 8px 14px;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
        box-sizing: border-box;

        span {
          min-width: 34px;
          height: 34px;
          line-height: 34px;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          padding: 0 8px;
          border-radius: 4px;
          text-align: center;
          color: var(--text-secondary, #5A5F6B);
          cursor: pointer;
          box-sizing: border-box;
          transition: color 0.2s ease, background 0.2s ease;
        }

        span:hover {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          color: var(--text-main, #1A1D24);
          background: var(--bg-tag, #F0EDE8);
        }

        .active_A-Z {
          color: var(--primary, #FF5A1F) !important;
          background: var(--primary-soft, #FCEDE5);
          font-weight: 500;
        }
      }
    }

    .games, .history {
      margin-bottom: 24px;

      ul {
        display: grid;
        grid-template-columns: repeat(10, 1fr);
        align-items: start;
        width: 100%;
        padding-top: 24px;
        gap: 22px 18px;

        li, a {
          width: 100%;
          min-width: 0;
          min-height: 116px;
          margin: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;
          border-radius: 4px;
          padding: 12px 8px 10px;
          border: 1px solid transparent;
          box-sizing: border-box;
          transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

          .game_img {
            width: 64px;
            height: 64px;
            border-radius: 4px;
            overflow: hidden;
            margin: 0 0 10px;
            background: var(--bg-card-soft, #F0EDE8);
            box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);

            img {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              object-fit: cover;
            }
          }

          .game_name {
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            line-height: 22px;
            color: var(--text-main, #111827);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        a:hover,
        li:hover {
          background: var(--bg-tag, #F0EDE8);
          border-color: rgba(26, 29, 36, 0.22);
          box-shadow: 0 10px 22px rgba(26, 29, 36, 0.14);
          transform: translateY(-3px);

          .game_name {
            color: var(--text-main, #1A1D24);
            font-weight: 500;
          }
        }
      }
    }

    .history {
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      margin-bottom: 0;

      .historyTitle {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        .titleText {
          padding: 24px 0 10px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
        }

        .clear {
          height: 32px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          background: transparent;
          border: 1px solid transparent;
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 0 12px;
          border-radius: 4px;
          transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

          i {
            margin: 0 6px 0 0;
            font-size: 15px;
          }
        }

        .clear:hover {
          color: var(--primary, #FF7A1A);
          background: var(--primary-soft, #FFF3E7);
          border-color: rgba(255, 122, 26, 0.18);
        }

      }

      ul {
        padding: 0;
      }
    }
  }
}
</style>
